<template>
  <li
    class="StatRowItem"
  >
    <Transition>
      <span
        :key="label"
        class="StatRowItem__wrapper"
      >
        <Stat
          v-model="modelValue"
          class="StatRowItem__value"
          tag="strong"
        />
        <span
          data-testid="label"
          class="StatRowItem__label"
        >{{ label }}</span>
      </span>
    </Transition>
  </li>
</template>

<script setup lang="ts">
import Stat from "./Stat.vue";

const modelValue = defineModel<number>({
  required: true,
});

const {
  label,
} = defineProps<{
  label: string,
}>();
</script>

<style lang="scss" scoped>
.StatRowItem {
  position: relative;
  perspective: 1000px;

  display: grid;
  grid-template-rows: 1fr;
  gap: 6px;
  justify-items: center;
  align-content: center;
  overflow: hidden;

  background-color: var(--themeColorNeutral50);
  color: var(--themeColorNeutral900);

  font: var(--fontFamilyMono);
  font-weight: var(--fontWeightMedium);

  & + & {
    border-left: solid 1px var(--themeColorNeutral100);
  }
}

.StatRowItem__wrapper {
  transform-style: preserve-3d;
  backface-visibility: hidden;

  display: grid;
  gap: 4px;
  justify-items: center;
  align-content: center;
  width: 100%;
  min-height: 88px;
  padding: 12px 8px;

  background-color: var(--themeColorNeutral0);

  transition: 350ms;
  transition-property: opacity, transform;

  &.v-leave-active {
    position: absolute;
  }

  &.v-enter-from {
    transform: rotateY(180deg);
    opacity: 0;
  }

  &.v-leave-to {
    transform: rotateY(-180deg);
    opacity: 0;
  }
}

.StatRowItem__value {
  font-family: var(--fontFamilyMono);
  font-size: 32px;
}

.StatRowItem__label {
  font-size: 14px;
  text-align: center;
  text-transform: uppercase;
  text-wrap: balance;
  line-height: 16px;
}
</style>
